<template>
  <div>
    <c-table
      ref="table"
      title="규제 DB 업로드 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="openPop"
    >
      <!-- 버튼 영역 -->
      <template v-slot:table-button>
        <q-btn-group outline>
          <c-btn v-if="editable" label="등록" icon="add" @btnClicked="openPop()" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'chemUpdateDbUpload',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'uploadDt',
            field: 'uploadDt',
            label: '업로드 일시',
            align: 'center',
            style: 'width:200px',
            type: 'link',
            sortable: true,
          },
          {
            name: 'statusName',
            field: 'statusName',
            label: '진행상태',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'cnt',
            field: 'cnt',
            label: '업로드 건 수',
            child: [
              {
                name: 'addCnt',
                field: 'addCnt',
                label: '신규',
                align: 'right',
                style: 'width:120px',
                sortable: true,
                type: 'cost',
              },
              {
                name: 'updateCnt',
                field: 'updateCnt',
                label: '변경',
                align: 'right',
                style: 'width:120px',
                sortable: true,
                type: 'cost',
              },
              {
                name: 'deleteCnt',
                field: 'deleteCnt',
                label: '삭제',
                align: 'right',
                style: 'width:120px',
                sortable: true,
                type: 'cost',
              },
              {
                name: 'noChangeCnt',
                field: 'noChangeCnt',
                label: '변동없음',
                align: 'right',
                style: 'width:120px',
                sortable: true,
                type: 'cost',
              },
              {
                name: 'totalCnt',
                field: 'totalCnt',
                label: '총계',
                align: 'right',
                style: 'width:120px',
                sortable: true,
                type: 'cost',
              },
            ]
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        width: '100%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.chm.regul.updateData.excelUpload.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    openPop(row) {
      this.popupOptions.title = '규제DB업로드';
      this.popupOptions.param = {
        mdmMaterialRegulatoryInfoExcelUploadId: row ? row.mdmMaterialRegulatoryInfoExcelUploadId : '',
        statusCd: row ? row.statusCd : 'CEUS000001',
      };
      this.popupOptions.target = () => import(`${'./chemUpdateDbUploadDetail.vue'}`);
      this.popupOptions.isFull = true;
      this.popupOptions.width = '100%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUploadPopup;
    },
    closeUploadPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
